import { getHtmlTextContent } from '../../utils/htmlUtils';
import { getSeatedPlayerFromPlayerId } from '../reducers/pokerReducer';
import { addHandRevealChatItem } from './chatActions';
export const CLEAR_BUBBLES_STATE = 'CLEAR_BUBBLES_STATE';
export const ADD_PLAYER_REVEALED_HAND_BUBBLE = 'ADD_PLAYER_REVEALED_HAND_BUBBLE';
export const ADD_PLAYER_AUTO_RELOAD_BUYIN_BUBBLE = 'ADD_PLAYER_AUTO_RELOAD_BUYIN_BUBBLE';
export const REMOVE_PLAYER_BUBBLE = 'REMOVE_PLAYER_BUBBLE';
export function clearBubblesState() {
    return {
        type: CLEAR_BUBBLES_STATE
    };
}
function addPlayerRevealedHandBubble(seatIndex, handName, cards) {
    return {
        type: ADD_PLAYER_REVEALED_HAND_BUBBLE,
        payload: { seatIndex, handName, cards }
    };
}
function addPlayerAutoReloadBuyinBubble(seatIndex) {
    return {
        type: ADD_PLAYER_AUTO_RELOAD_BUYIN_BUBBLE,
        payload: seatIndex
    };
}
export function removePlayerBubble(seatIndex, id) {
    return {
        type: REMOVE_PLAYER_BUBBLE,
        payload: { seatIndex, id }
    };
}
/**
 * TODO: Rather than trying to handle bubbles with specific content, add new server outbounds specific to the action taking place,
 * and add support for those new messages in the client.
 */
export function thunkShowPlayerBubbleFromInbound(inbound) {
    return function (dispatch, getState) {
        const state = getState();
        const { playerId, cards, html } = inbound;
        if (cards.length) {
            // hand revealing bubble
            const seatedPlayer = getSeatedPlayerFromPlayerId(state, playerId);
            if (seatedPlayer) {
                const handName = getHtmlTextContent(html);
                if (handName) {
                    dispatch(addPlayerRevealedHandBubble(seatedPlayer.seatIndex, handName, cards));
                    dispatch(addHandRevealChatItem(seatedPlayer.name, handName, cards, state.poker.communityCards, state.poker.rabbits));
                }
            }
        }
        else {
            // handle supported non-reveal bubbles
            const text = getHtmlTextContent(html);
            if (text) {
                if (text.toLowerCase().indexOf('reload') !== -1) {
                    // auto-reload buy-in bubble
                    const seatedPlayer = getSeatedPlayerFromPlayerId(state, playerId);
                    if (seatedPlayer) {
                        dispatch(addPlayerAutoReloadBuyinBubble(seatedPlayer.seatIndex));
                    }
                }
            }
        }
    };
}
